import { css, cx } from '@flipster/styled-system/css';

const center = css({ pos: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' });

export interface RewardImageProps {
  imageUrl: string;
  blur?: number; // 0 ~ 1
}
export const RewardImage = ({ imageUrl, blur }: RewardImageProps) => {
  return (
    <div className={css({ pos: 'relative', w: 107, h: 107 })}>
      <img
        alt=''
        width={107}
        src={imageUrl}
        className={cx(center, css({ transition: 'filter 0.3s', userSelect: 'none', pointerEvents: 'none' }))}
        style={
          blur
            ? { filter: `saturate(${(1 - blur).toFixed(2)}) blur(${lerp(5, blur * 30, blur).toFixed(1)}px)` }
            : undefined
        }
      />
      {(blur || 0) > 0 ? (
        <span className={cx(center, css({ textStyle: 'Display/XXL', color: 'content.default.level-0' }))}>?</span>
      ) : undefined}
    </div>
  );
};

function lerp(a: number, b: number, t: number) {
  return a + (b - a) * t;
}
